import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./../components/dashboard/sidebar";
import Dashnavbar from "./../components/dashboard/dashnavbar";
import { notificationsSocket } from "../socket";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";

const Dashboard = () => {

// useEffect(()=>{
//   const loginData = secureLocalStorage.getItem("loginCredentials");
//   notificationsSocket.emit("register", loginData.user.id);

//   // Listen for dataEvent emitted by the server
//   notificationsSocket.on("dataEvent", (data) => {
//     console.log("Received data from server:", data);
  
//   });
// },[])

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      <div className="flex overflow-x-hidden relative min-h-screen bg-dashbg ">
        <div className="max-md:p-[0px]">
          <Sidebar isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
        </div>

        <div className=" p-[18px] ml-auto max-w-full w-[calc(100vw-270px)] max-md:w-full max-md:ml-0 max-sm:px-[20px] max-sm:py-[10px]">
          <Dashnavbar toggleDrawer={toggleDrawer} />
          <div className="page-dom">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
